const STORAGE_KEY = "boonline.statistics.views.v1";
const MAX_VIEWS = 20;

export function readSavedViews(storage) {
  try {
    const targetStorage = storage || window.localStorage;
    const value = JSON.parse(targetStorage.getItem(STORAGE_KEY) || "[]");
    return Array.isArray(value) ? value.filter((view) =>
      view && typeof view.id === "string" && typeof view.name === "string" && view.filters
    ).slice(0, MAX_VIEWS) : [];
  } catch {
    return [];
  }
}

export function writeSavedViews(views, storage) {
  try {
    const targetStorage = storage || window.localStorage;
    targetStorage.setItem(STORAGE_KEY, JSON.stringify(views.slice(0, MAX_VIEWS)));
    return true;
  } catch {
    return false;
  }
}

export { STORAGE_KEY as SAVED_VIEWS_STORAGE_KEY };
